import { useQnaHook } from "../useQnaHook";


export default function QnaSelector() {
    const {
        selectedQnaPage,
        setSelectedQnaPage,
    } = useQnaHook();

    return (
        <div className='my-8 flex justify-center items-center flex-col'>
            <p className='text-2xl font-normal mb-4'>Manage QnA's</p>
            <p className='text-lg font-light mb-4'>Select an action to perform on QnA's</p>
            <div className='flex justify-between items-center my-4'>
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => setSelectedQnaPage(1)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>List QnA's</button>
                    <button
                        onClick={() => setSelectedQnaPage(2)}
                        className='bg-green-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Add New QnA</button>
                </div>
            </div>
        </div>
    )
}
